export class MudancaDoacaoDto {
  idAnuncio: number;
  necessitaMotivoMudancaOrdemDoacao: boolean;
  necessitaMotivoMudancaQtdeDoacao: boolean;
  motivoMudancaOrdemDoacao: string;
  motivoMudancaQtdeDoacao: string;
}
